import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { DelayCategory } from "../models/CatalogCategory";

type Props = {
	setSelectedRowData: (category: DelayCategory) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
};

export const useCategoriesOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
}: Props) => {
	const getMenuOptions = (data: DelayCategory) => {
		let options: MenuOptionType[] = [];

		options = options.concat([
			{
				name: "New Category",
				key: "new_category",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Category",
					key: "edit_category",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Category",
					key: "delete_category",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
